import {createAction} from '@reduxjs/toolkit'
import {IdHandoverRecordStateDataItem, typeHandoverRecordFilters} from './dHandoverRecordReducer'
import {typePagination, typeRequestPagination} from '../system/constants'

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dHRecordSetDataAC = createAction(
  'D_HRECORD_SET_DATA',
  (dataList: IdHandoverRecordStateDataItem[]) => ({payload: dataList})
)

// Action creator of saga set data
export const dHRecordSetDataSagaAC = createAction(
  'D_HRECORD_SET_DATA_SAGA',
  (
    filters: typeHandoverRecordFilters,
    paginationRequest: typeRequestPagination
  ) => ({payload: { filters, paginationRequest}})
)

//

// Action creator of set pagination
export const dHRecordSetPaginationAC = createAction(
  'D_HRECORD_SET_PAGINATION',
  (
      pagination: typePagination,
  ) => ({payload: {pagination}})
)

// Action creator of set itemsForPage in pagination
export const dHRecordSetItemsForPageAC = createAction(
    'D_HRECORD_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dHRecordSetPageNumberAC = createAction(
  'D_HRECORD_SET_PAGE_NUMBER',
  (
      pageNumber: number,
  ) => ({payload: {pageNumber}})
)

// ---------------------------------------------------------------------------------------------------------------------

// Action creator of clear filtersForm
export const dHRecordClearFiltersAC = createAction(
  'D_HRECORD_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dHRecordSetFiltersAC = createAction(
  'D_HRECORD_SET_FILTERS',
  (filtersObject: typeHandoverRecordFilters) => ({payload: filtersObject})
)

// Action creator of set filtersForm saga
export const dHRecordSetFiltersSagaAC = createAction(
  'D_HRECORD_SET_FILTERS_SAGA',
  ( filtersObject: typeHandoverRecordFilters) => ({payload: { filtersObject}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dHRecordSetDetailItemAC = createAction(
  'D_HRECORD_SET_DETAIL_ITEM',
  (detailItemId: string) => ({payload: detailItemId})
)


//
